/**
 * @generated SignedSource<<2e86eb69bd939e78f0db6f7d5240873e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appSlack_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly slackEnabled: boolean | null;
    readonly newSlackEnabled: boolean | null;
  } | null;
  readonly " $fragmentType": "appSlack_viewer";
};
export type appSlack_viewer$key = {
  readonly " $data"?: appSlack_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"appSlack_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appSlack_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slackEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newSlackEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "0e686c947e0803d0d704bf57ae6355bc";

export default node;
